<template>
    <div class="accordian" :class="[open ? 'open' : '']">
        <div class="preview" @click="open = !open; $root.$emit('opened', preview)">
            <div class="preview-copy">
                <div class="preview-icon"><img  :src="require('@/assets/images/' + icon)" alt=""></div>
                <p class="yellow" v-html="preview" />
            </div>
            <RoundIcon icon="icon_close.svg" />
        </div>
        <transition
            appear
            name="expand"
            mode="out-in"
            @before-enter="beforeEnter"
            @enter="enter"
            @after-enter="afterEnter"
            @before-leave="beforeLeave"
            @leave="leave"
        >
            <div class="info" v-show="open">
                <div>
                    <div class='item' v-for="(listItem, id) in info" :key="id">{{listItem}}</div>
                </div>
            </div>    
        </transition>    
    </div>      
</template>

<script>
import RoundIcon from "@/patterns/RoundIcon.vue";
export default {
  name: "Accordian",  
  data: () => ({
      open:false
  }),
  components: { RoundIcon },
  props: { icon:String, preview:String, info:Array},  
  methods : {
    beforeEnter: function (el) {
        el.style.height = 0;
    },
    enter: function (el) {
        el.style.height = el.scrollHeight + "px";
    },
    afterEnter: function (el) {
        el.style.height = "auto";
    },
    beforeLeave: function (el) {
        el.style.height = el.scrollHeight + "px";
    },
    leave: function (el) {
        el.style.height = el.scrollHeight + "px";
        this.$nextTick(() => {
            el.style.height = "0px";
        });
    },
    otherOpened(preview) {
        console.log(preview)
        if(this.preview !== preview) {
            this.open = false;
        }
      },
    },
  mounted() {
    this.$root.$on('opened', this.otherOpened);
  }  
};
</script>


<style lang="scss">
.accordian {
    .icon {
        img {
                transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
        }
    }
    &.open {
        .icon img {
            transform: translate(-50%, -50%) rotateZ(45deg);
        } 
    }
}
</style>
<style lang="scss" scoped>
.accordian {
    margin-bottom:10px;
    background: linear-gradient(135deg, #313131 0%, #141414 100%);
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.2);
    border-radius: 10px;
    user-select: none;
    cursor: pointer;
}
.preview {        
    position:relative;
    padding:20px;
    .preview-icon {
        width:25px;
        margin-right:25px;
        position: relative;
        img {
            position: relative;
            top:50%;
            transform:translateY(-50%);
        }
    }
    .preview-copy {
        display:flex;
        margin-right:10px;
        img {
            flex-grow: 0;
            flex-shrink: 0;            
        }
        p {
            flex-grow: 1;
            margin:0;
        }
    }
    .icon {
        right:0;
        top:50%;
        position:absolute;
        transform:translate(50%, -50%);        
    }

}
.info {    
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    background-color: #191919;
    transition: height 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
    > div {
        margin-left:70px;
        padding:15px 0;
    }
    .item {
        color: #FFFFFF;
        font-family: "Montserrat";
        font-size: 0.9em;
        letter-spacing: 0;
        line-height: 1.5em;
        max-width: 260px;
        position: relative;
        padding-left:18px;
        &:before {
            content: " ";
            width:3px;
            height:100%;
            background: linear-gradient(180deg, #F5831F 0%, #FFD62F 100%);
            display:inline-block;
            position: absolute;
            top:0;
            left:0;
        }
        &:not(:last-child) {
            margin-bottom:25px;
        }
    }
}
</style>